module.exports = __webpack_public_path__ + "348a89d8f1b41abe4674a725178528bb.svg";